<template>
  <div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-light ">
    <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " data-menu-vertical="true" data-menu-scrollable="false" data-menu-dropdown-timeout="500">
      <services-nav v-if="services"></services-nav>
      <dashboard-nav v-else></dashboard-nav>
    </div>
  </div>
</template>
<script>
import DashboardNav from "../partials/DashboardNav";
import ServicesNav from "../partials/ServicesNav";

export default {
  name: "sidebar",
  data: function() {
    return {
      dashboard: true
    };
  },
  components: {
    DashboardNav,
    ServicesNav
  },
  computed: {
    services() {
      return this.$store.state.services;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/navigation/SideBar.vue